import React from 'react';
import { Tag, Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function OfferCard({ offer, showFullDetails = false }) {
    const { isAuthenticated, isMember } = useAuth();
    const navigate = useNavigate();
    
    const isMembersOnly = offer.audience === 'members';
    const canAccess = !isMembersOnly || (isAuthenticated && isMember);

    const handleClick = () => {
        if (isMembersOnly && !canAccess) {
            navigate('/login', { state: { message: 'Join Friend of Burston to unlock this offer.' } });
        }
    };

    return (
        <div
            className={`card-interactive ${!canAccess ? 'opacity-90' : ''}`}
            onClick={handleClick}
            data-testid={`offer-card-${offer.id}`}
        >
            <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                        {isMembersOnly ? (
                            <span className="badge-members flex items-center gap-1">
                                {!canAccess && <Lock className="w-3 h-3" />}
                                Members
                            </span>
                        ) : (
                            <span className="badge-everyone">Everyone</span>
                        )}
                    </div>
                    <h3 className="text-lg font-bold text-foreground mb-2">{offer.title}</h3>
                    {(showFullDetails || !isMembersOnly || canAccess) && (
                        <p className="text-muted-foreground">{offer.description}</p>
                    )}
                    {!canAccess && isMembersOnly && (
                        <p className="text-accent font-medium mt-2 flex items-center gap-1">
                            <Lock className="w-4 h-4" />
                            Login to view this offer
                        </p>
                    )}
                </div>
                <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                        <Tag className="w-6 h-6 text-primary" />
                    </div>
                </div>
            </div>
            <div className="mt-4 pt-4 border-t border-primary/10">
                <p className="text-sm text-muted-foreground">
                    Valid until: {new Date(offer.valid_to).toLocaleDateString('en-GB', { 
                        day: 'numeric', 
                        month: 'long', 
                        year: 'numeric' 
                    })}
                </p>
            </div>
        </div>
    );
}

export default OfferCard;
